import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/atoms/basic-headline';
import 'ShopUiBundle/components/molecules/video-player';

import './style.scss';

// tslint:disable-next-line
register('catalog-category-title-with-video', () => import(/* webpackMode: "lazy" */'./catalog-category-title-with-video'));
